import React from 'react';
import TablaSolicitudObstruccionTemporal from './Tablas/TablaSolicitudObstruccionTemporal';
import GraficoSolicitudObstruccionTemporal from './Graficos/GraficoSolicitudObstruccionTemporal';
import { VStack, Heading } from '@chakra-ui/react';
import ObrasObstruccionTemporalDashboard from './Dashboard/ObrasObstruccionTemporalDashboard';

const ObrasObstruccionTemporal: React.FC = () => {
  return (
    <VStack spacing={8} align="stretch">
      <Heading size="lg" textAlign="center" color="blue.700">
        Obstrucción Temporal
      </Heading>
      <ObrasObstruccionTemporalDashboard/>
      <TablaSolicitudObstruccionTemporal />
      {/* <GraficoSolicitudObstruccionTemporal /> */}
    </VStack>
  );
};

export default ObrasObstruccionTemporal;
